"use client"

import Image from "next/image"

import useSlowLoading from "@/lib/useSlowLoading"

import * as styles from "./PublicationImage.css"

type PublicationImageProps = {
	url: string
	title: string
}
export default function PublicationImage({
	url,
	title,
}: PublicationImageProps) {
	const {
		isLoaded: isImageLoaded,
		isSlowToLoad: isImageSlowToLoad,
		onLoaded: onImageLoaded,
	} = useSlowLoading()

	let imageStatus = isImageLoaded
		? ("loaded" as const)
		: isImageSlowToLoad
			? ("slowLoading" as const)
			: ("loading" as const)

	return (
		<figure className={styles.figure({ status: imageStatus })} aria-hidden>
			<Image
				className={styles.image}
				src={`/${url}`}
				fill
				sizes={styles.size}
				alt={`Illustration for "${title}"`}
				onLoad={() => {
					onImageLoaded()
				}}
			/>
		</figure>
	)
}
